export default {
  goodDeal: { id: 'good_deal', defaultMessage: 'Hot deal' },
  soldOut: {
    id: 'already_sold',
    defaultMessage: 'Sold out',
  },
}
